import { QuoteSearchType } from '@lio/rule-engine';
import { QuoteType } from '@models/quotes';
import { NonTerminalQuoteStatuses } from '@pages/Home/UnderwriterHome/constants';
import { QuoteDataGridType } from '@pages/Quotes/QuotesTable/DataGrid.constants';

export const getDefaultFilters = (viewType: QuoteDataGridType) => {
  switch (viewType) {
    case QuoteDataGridType.UWHomePageAllTransaction:
      return {
        forcedFilters: {},
        defaultFilters: { quoteType: null, underwriterId: null, statuses: NonTerminalQuoteStatuses },
      };
    case QuoteDataGridType.UWHomePageRecentlyViewed:
      return { forcedFilters: { searchType: QuoteSearchType.Viewed }, defaultFilters: {} };
    case QuoteDataGridType.UWHomePageNewBusiness:
      return { forcedFilters: {}, defaultFilters: { quoteType: [QuoteType.NewBusiness], underwriterId: null } };
    case QuoteDataGridType.UWHomePageRenewals:
      return { forcedFilters: {}, defaultFilters: { quoteType: [QuoteType.Renewal], underwriterId: null } };
    case QuoteDataGridType.UWHomePageEndorsements:
      return { forcedFilters: {}, defaultFilters: { quoteType: [QuoteType.Endorsement], underwriterId: null } };
    case QuoteDataGridType.QuoteTypeRenewal:
      return {
        forcedFilters: { quoteType: [QuoteType.Renewal] },
        defaultFilters: {},
      };
    case QuoteDataGridType.QuoteTypeNewBusiness:
      return { forcedFilters: { quoteType: [QuoteType.NewBusiness] }, defaultFilters: {} };
    default:
      return {};
  }
};
